<ng-container *ngIf="!checkAuthenticationInProgress">
    <div class="screen-container _relative">
        <div *ngIf="!loading" class="_relative xs:_container _mx-auto _flex _h-full _items-start">
            <div class="_grid _grid-cols-12 content-container _w-full">
                <div class="_col-span-12 sm:_col-span-4 _relative">
                    <app-login 
                        [role]="role"
                        [formData]="formData"
                        [inviteCode]="inviteCode"
                        [inviteAccepted]="inviteAlreadyAccepted"
                        [activeTab]="activeTab"
                        [onloadMessage]="onloadMessage"
                        [mobileDrawerOpen]="mobileDrawerOpen"
                        [existingUser]="existingUser"
                        [selfSignup]="selfSignup"
                        [isWhiteLabelSite]="isWhiteLabelSite"
                        (tabSwitched)="updateActiveTab($event)"
                        (mobileDrawerClosed)="closeMobileDrawer()">
                    </app-login>
                </div>
                <div class="_col-span-12 sm:_col-span-8 _relative _bg-primary-1-tint-20 sm:_bg-white listing-container _overflow-visible sm:_overflow-scroll _no-scrollbar">
                    <div class="_sticky _z-20 _top-0 _py-3 _px-5 _bg-white background-image sm-max:_shadow-bottom"
                        [ngClass]="isWhiteLabelSite ? 'xs:_py-3 sm-max:_flex sm-max:_justify-between' : 'xs:_py-6'">
                        <div class="_flex _justify-between _mb-2 sm:_hidden">
                            <div *ngIf="!isWhiteLabelSite" class="_block">
                                <a href="https://reservest.com/contactus" 
                                    appTrackClick [metric]="'User Get In Touch Clicked'"
                                    class="_button-secondary"
                                    target="_blank">
                                    Get in touch
                                </a>
                            </div>
                            <div class="_flex _gap-1 xs:_gap-2">
                                <ng-container *ngIf="!role">
                                    <app-button [onClick]="openMobileDrawer.bind(this, 1)">Login</app-button>
                                    <!-- Temporarily remove this until hubspot form is instegrated -->
                                    <!-- <app-button [onClick]="openMobileDrawer.bind(this, 2)">Sign up</app-button> -->
                                </ng-container> 
                                <ng-container *ngIf="role">
                                    <app-button [onClick]="openMobileDrawer.bind(this, 2)">Accept Invitation</app-button>
                                </ng-container> 
                            </div>
                        </div>
                        <div class="_flex _items-center"
                            [ngClass]="isWhiteLabelSite ? '_justify-end' : '_justify-between'">
                            <ng-container *ngIf="!isWhiteLabelSite">
                                <div class="_flex _items-center">
                                    <span class="_h2 _mr-2">Welcome to</span> <img class="_h-5 _mb-nudge-3" app-logo />
                                </div>
                                <div class="_hidden sm:_block">
                                    <a href="https://reservest.com/contactus" 
                                        appTrackClick [metric]="'User Get In Touch Clicked'"
                                        class="_button-primary"
                                        target="_blank">
                                        Get in touch
                                    </a>
                                </div>
                            </ng-container>
                            <img *ngIf="isWhiteLabelSite" app-logo size="xlarge"/>
                        </div>
                        <div *ngIf="!isWhiteLabelSite" class="_text-lg">Your agents-only portal for luxury corporate-managed multi-bedroom accommodation</div>    
                    </div>
                    <div class="_flex _flex-col _mt-6 _px-5">
                        <div class="_mb-4 _text-md">Over 3000 listings worldwide</div>
                        <ng-container *ngIf="publicListing?.publicListingEntries && !listingLoading">
                            <div *ngFor="let listing of publicListing.publicListingEntries" class="_mb-6 xs:_mb-8 md:_mb-10">
                                <app-property-listing-card 
                                    [publicListing]="listing" 
                                    [consumerView]="isWhiteLabelSite">
                                </app-property-listing-card>
                            </div>
                        </ng-container>
                        <app-loading-spinner 
                            [show]="listingLoading" 
                            [positionAbsolute]="true">
                        </app-loading-spinner>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="loading">
            <i class="fas fa-circle-notch fa-spin _center-xy-absolute _text-5xl _text-white"></i>
        </ng-container> 
    </div>
</ng-container>
<ng-container *ngIf="checkAuthenticationInProgress">
    <div class="_text-xl _h-full _flex _flex-col _items-center _center-xy">
        <i class="fas fa-circle-notch fa-spin _z-20"></i>
        <span class="_ml-1 _mt-2">Loading</span>
    </div>
</ng-container>
